const Statistics = () => import('../modules/xmsb/statistics/PageXmsbStatistics')
const Resultpublish = () => import('../modules/xmsb/resultpublish/PageResultpublish')
const ImportKJJapplyhistory = () => import('../modules/xmsb/applyhistory/kjj/ImportKJJapplyhistory')
const ImportNyprojectHistory = () => import('../modules/xmsb/applyhistory/ny/ImportNyprojectHistory')
const ImportApplyProject = () => import('../modules/xmsb/applyproject/ImportApplyProject')
const deptApplyAmountHistory = () => import('../modules/xmsb/applyhistory/historyList')
const cxsdStatistics = () => import('../modules/cxsd/cxsdStatistics')
const PlatformCountPage = () => import('../modules/xmsb/platformCount/platformCountPage')
const scsqyzjhzb = () => import('../modules/xmsb/applyhistory/scsqyzjhzb')
export default [{
  path: '/statistics',
  name: 'statistics',
  component: Statistics,
  meta: {
    title: '老平台项目申报数据',
    isBlack: true
  },
},

{
  path: '/resultpublish',
  name: 'resultpublish',
  component: Resultpublish,
  meta: {
    title: '结果公示发布',
  },
},

{
  path: '/importKJJapplyhistory',
  name: 'importKJJapplyhistory',
  component: ImportKJJapplyhistory,
  meta: {
    title: '导入科技局已申报的项目',
    isBlack: true
  },
},
{
  path: '/importApplyProject',
  name: 'ImportApplyProject',
  component: ImportApplyProject,
  meta: {
    needLogin: false,
    title: '导入农业科技申报项目',
    isBlack: true
  },
},

{
  path: '/importNyprojectHistory',
  name: 'importNyprojectHistory',
  component: ImportNyprojectHistory,
  meta: {
    title: '导入已申报的三农项目',
    isBlack: true
  },
},
{
  path: '/deptApplyAmountHistory',
  name: 'deptApplyAmountHistory',
  component: deptApplyAmountHistory,
  meta: {
    title: '申报下达资金统计',
    isBlack: true
  },
},
{
  path: '/CXZCZT_Statistics',
  name: 'cxsdStatistics',
  component: cxsdStatistics,
  meta: {
    title: '创新政策专题统计',
    isBlack: true
  },
},
{
  path: '/scsqyzjhzb',
  name: 'scsqyzjhzb',
  component: scsqyzjhzb,
  meta: {
    title: '双创涉企资金汇总',
    isBlack: true
  },
},
{
  path: '/platformCountPage',
  name: 'platformCountPage',
  component: PlatformCountPage,
  meta: {
    title: '双创平台月度统计',
    isBlack: true
  },
},
]
